import * as st from './styles.module.scss';

interface Props {
  onClick: () => void;
  cost: number;
}

export const ButtonPay: React.FC<Props> = ({ onClick, cost }) => {
  const buttonTitle = cost === 0 ? 'Присоединиться' : 'Оплатить';
  return (
    <button className={st.button} onClick={onClick}>
      {buttonTitle}
    </button>
  );
};
